const BASE_DOWNLOAD_URL = '/api/node/v1/parts/export'
export const TEMPLATE_CONFIG = {
  po: {
    templateKey: 'versions',
    url: BASE_DOWNLOAD_URL,
    archiveType: ['templatesArchive', 'PO'],
    apiUrl: 'template',
  },
  prices: {
    templateKey: 'finalTemplates',
    url: BASE_DOWNLOAD_URL,
    archiveType: ['templatesArchive', 'POfinal'],
    apiUrl: 'template',
  },
  final: {
    templateKey: 'finalTemplates',
    url: BASE_DOWNLOAD_URL,
    archiveType: ['templatesArchive', 'POfinal'],
    apiUrl: 'template',
  },
  're-sign': {
    templateKey: 'finalTemplates',
    url: BASE_DOWNLOAD_URL,
    archiveType: ['templatesArchive', 'POfinal'],
    apiUrl: 'template',
  },
  unsign: {
    templateKey: 'finalTemplates',
    url: BASE_DOWNLOAD_URL,
    archiveType: ['templatesArchive', 'POfinal'],
    apiUrl: 'template',
  },
  PL: {
    templateKey: 'plTemplates',
    url: `${BASE_DOWNLOAD_URL}/PLTemplate`,
    archiveType: ['templatesArchive', 'PL'],
    apiUrl: 'packingGroup',
  },
  FinalPL: {
    templateKey: 'finalPlTemplates',
    url: `${BASE_DOWNLOAD_URL}/PLTemplate`,
    archiveType: ['templatesArchive', 'PLfinal'],
    apiUrl: 'packingGroup',
  },
  part: {
    url: BASE_DOWNLOAD_URL,
  },
  PartPL: {
    url: `${BASE_DOWNLOAD_URL}/PLTemplate`,
  },
  finalPartPl: {
    url: `${BASE_DOWNLOAD_URL}/PLTemplate`,
  },
  Inspection: {
    templateKey: 'irTemplates',
    url: `${BASE_DOWNLOAD_URL}/inspectionReport`,
  },
  PartIR: {
    url: `${BASE_DOWNLOAD_URL}/inspectionReport`,
  },
}
